"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignConfirmationIndividualToJSON = exports.CampaignConfirmationIndividualFromJSONTyped = exports.CampaignConfirmationIndividualFromJSON = exports.instanceOfCampaignConfirmationIndividual = void 0;
var runtime_1 = require("../runtime");
var OrderItem_1 = require("./OrderItem");
/**
 * Check if a given object implements the CampaignConfirmationIndividual interface.
 */
function instanceOfCampaignConfirmationIndividual(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaignConfirmationIndividual = instanceOfCampaignConfirmationIndividual;
function CampaignConfirmationIndividualFromJSON(json) {
    return CampaignConfirmationIndividualFromJSONTyped(json, false);
}
exports.CampaignConfirmationIndividualFromJSON = CampaignConfirmationIndividualFromJSON;
function CampaignConfirmationIndividualFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(OrderItem_1.OrderItemFromJSON)),
    };
}
exports.CampaignConfirmationIndividualFromJSONTyped = CampaignConfirmationIndividualFromJSONTyped;
function CampaignConfirmationIndividualToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(OrderItem_1.OrderItemToJSON)),
    };
}
exports.CampaignConfirmationIndividualToJSON = CampaignConfirmationIndividualToJSON;
